module.exports = __webpack_public_path__ + "static/media/hotel-17.fdb8f0c3.jpg";